import { useState, useEffect } from "react";


const Initials = ({ initials }) => {
    const initialsArray = initials.split('');

    return (
      <>
          {initialsArray.map((letter, index) => (
              <span key={index}>{letter}</span>
          ))}
      </>
    );
};

export default Initials;
